export default __webpack_public_path__ + "static/media/career-02.e1be3646.jpg";